import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";
import { FaMinusCircle } from "react-icons/fa";

import "./PaymentSelect.scss";

const BootstrapInput = withStyles(theme => ({
  root: {
    "label + &": {
      marginTop: theme.spacing.unit * 3
    }
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    // border: "1px solid #ced4da",
    boxShadow: "0px 4px 13px rgba(0, 0, 0, 0.06)",
    fontSize: 16,
    width: "auto",
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  }
}))(InputBase);

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    width: "100%"
  }
});

class PaymentSelect extends React.Component {
  state = {
    selectedPayment: 0
  };

  componentDidMount() {
    this.props.paymentMethods.forEach((method, index) => {
      if (method.isDefault) this.setState({ selectedPayment: index });
    });
  }

  handleChange = event => {
    this.setState({ selectedPayment: event.target.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <form
        className={classes.root}
        autoComplete="off"
        onSubmit={e => e.preventDefault()}
      >
        <FormControl className={classes.margin}>
          <Select
            value={this.state.selectedPayment}
            onChange={this.handleChange}
            input={<BootstrapInput name="age" id="age-customized-select" />}
          >
            <MenuItem value={-1}>None</MenuItem>
            {this.props.paymentMethods &&
              this.props.paymentMethods.map((method, index) => {
                const { name, bank, last4digits } = method;

                return (
                  <MenuItem key={index} value={index} className="payMenuItem">
                    <div className="menuItemContainer">
                      <img
                        src={require("../../assets/bank_logos/chase.png")}
                        alt="bank logo"
                      />
                      <div style={{ flex: 1 }}>
                        <div className="nameContainer">
                          {index === this.state.selectedPayment && (
                            <span>DEFAULT</span>
                          )}
                          <h4>{name}</h4>
                        </div>

                        <p>
                          {bank}, {last4digits}
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={() => alert("delete funding source")}
                      >
                        <FaMinusCircle size={20} />
                      </button>
                    </div>
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </form>
    );
  }
}

PaymentSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  paymentMethods: PropTypes.array
};

export default withStyles(styles)(PaymentSelect);
